export default function smoothPanAndZoom(
  map,
  startCenter,
  endCenter,
  startZoom,
  endZoom,
  duration
) {
  if (!map) return;

  const steps = 240;
  const stepDuration = Math.floor(duration / steps);
  let currentStep = 0;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function animate() {
    if (currentStep >= steps) return;

    const progress = easeInOutCubic(currentStep / steps);

    const lat = startCenter.lat + (endCenter.lat - startCenter.lat) * progress;
    const lng = startCenter.lng + (endCenter.lng - startCenter.lng) * progress;

    const zoom = startZoom + (endZoom - startZoom) * progress;

    map.panTo({ lat, lng });
    map.setZoom(zoom);

    currentStep++;

    if (currentStep < steps) {
      setTimeout(animate, stepDuration);
    } else {
      map.panTo(endCenter);
      map.setZoom(endZoom);
    }
  }

  animate();
}
